import axios from 'axios'

export const getAppOnboardingNotification = () => {
  return axios.get('/finance/appOnboardingNotification')
}

export const closeAppOnboardingNotification = (id) => {
  return axios.patch(`/finance/appOnboardingNotification/${id}/close`)
}

export const clickAppOnboardingNotification = (id) => {
  return axios.patch(`/finance/appOnboardingNotification/${id}/click`)
}
